// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb96bb71","453":"4ce23f45","732":"5310bee4"}[chunkId] + ".chunk.js";
};